import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 57057EA1-1BA7-49F3-A8C7-51AF633DED68
 * name currency-rub
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-rub.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CurrencyRubIcon = createSvgIcon(<><path d="M13.5 3H7V12H5V14H7V16H5V18H7V21H9V18H13V16H9V14H13.5C16.54 14 19 11.54 19 8.5S16.54 3 13.5 3M13.5 12H9V5H13.5C15.43 5 17 6.57 17 8.5S15.43 12 13.5 12Z" /></>, 'CurrencyRubIcon');
export default CurrencyRubIcon